module.exports = __webpack_public_path__ + "img/bind_phone_qrcode.60a5b28b.jpg";